import React, { useState, useEffect } from "react";
import { Card, Button, Col, Row } from "react-bootstrap";
import { FaGlobeAmericas } from "react-icons/fa";
import LeagueCard from "./Leagues/LeagueCard";
import { useNavigate } from "react-router-dom";
import ViewLeagueCard from "./Leagues/ViewLeagueCard";

const FeaturedLeaguesComponent = ({ featuredLeagues }) => {
	const [visibleLeagues, setVisibleLeagues] = useState(5);
	const navigate = useNavigate();

	const handleShowMore = () => {
		setVisibleLeagues((prevVisible) => prevVisible + 10);
	};

	const handleViewLeague = (leagueId) => {
		navigate(`/league/${leagueId}`);
	};

	return (
		<div className="mx-sm-4 mt-5">
			<div className="text-start w-100 fs-3 fw-bold text-light ms-3 mb-3">
				<FaGlobeAmericas className="mb-1 me-2" />
				Global Leagues
			</div>
			<div className="pb-1">
				{featuredLeagues.map((league) => (
					<ViewLeagueCard
						key={league?._id}
						league={league}
						onViewLeague={handleViewLeague}
					/>
				))}
			</div>
			<div className="d-flex flex-row justify-content-center mb-3">
				{featuredLeagues.length > visibleLeagues && (
					<Button variant="outline-success" onClick={handleShowMore}>
						Show 10 More
					</Button>
				)}
			</div>
		</div>
	);
};

export default FeaturedLeaguesComponent;
